var map = {
	"./+.svg": "8120",
	"./Arrow_Box_Left.svg": "b75c",
	"./Arrow_Box_Left_Green.svg": "8239",
	"./Arrow_Box_Right.svg": "0089",
	"./Arrow_Down.svg": "fed3",
	"./Arrow_Down_white.svg": "2ca2",
	"./Arrow_Left.svg": "6164",
	"./Arrow_Left2.svg": "c433",
	"./Arrow_Left_Circle.svg": "cf77",
	"./Arrow_Left_Long.svg": "7fd9",
	"./Arrow_Left_White.svg": "cd3a",
	"./Arrow_Left_black.svg": "352b",
	"./Arrow_Right.svg": "3b34",
	"./Arrow_Up.svg": "489d",
	"./Avatar.svg": "13c0",
	"./Avatar_Small.svg": "b06f",
	"./Back_Down.svg": "c4a5",
	"./Back_Up.svg": "bee6",
	"./Back_Up_2.svg": "2c14",
	"./Benefits_1.svg": "ab1f",
	"./Benefits_2.svg": "72cc",
	"./Benefits_3.svg": "3d1b",
	"./Benefits_4.svg": "f544",
	"./Calendar.svg": "01b3",
	"./Clipboard-Done.svg": "9b4e",
	"./Clock.svg": "5ac8",
	"./Clock_u.svg": "982f",
	"./Download.svg": "8b76",
	"./Edit.svg": "f7fd",
	"./Edit_white.svg": "6313",
	"./Ellipse.svg": "6c34",
	"./Future-Education.svg": "9475",
	"./Home_Shape_2.svg": "0c2d",
	"./Home_Shape_3.svg": "d9d5",
	"./Illustration_Home_1.svg": "d396",
	"./Illustration_Home_2.svg": "26e4",
	"./Illustration_Home_2_1.svg": "a4d2",
	"./Illustration_Home_3.svg": "0e0b",
	"./Info-Triangle.svg": "1315",
	"./Letter.svg": "06ab",
	"./Location.svg": "fa8e",
	"./Logo_Footer.svg": "218e",
	"./Logo_Header.svg": "6f11",
	"./Logo_Header2.svg": "92fe",
	"./Logo_admin.svg": "5346",
	"./M3.svg": "577c",
	"./M4.svg": "1b3e",
	"./Paper-Note.svg": "cb6c",
	"./Path -10.svg": "12e6",
	"./Path16409.svg": "6da4",
	"./Path3.svg": "11ca",
	"./Ripple.svg": "2a83",
	"./Search.svg": "4c2b",
	"./Search_white.svg": "f43a",
	"./Shape_Title.svg": "0d55",
	"./Status_No.svg": "0354",
	"./Status_Yes.svg": "f98c",
	"./Switch-2.svg": "4a6a",
	"./Switch.svg": "c2d5",
	"./Tick-Circle.svg": "0d52",
	"./Tick-Circle_u.svg": "2cc4",
	"./Tick.svg": "53c4",
	"./Trash-Bin.svg": "5f10",
	"./User.svg": "68c2",
	"./address.svg": "c275",
	"./arrowRightCircle.svg": "3b70",
	"./arrow_green.svg": "57b9",
	"./arrow_orange.svg": "a458",
	"./best_off.svg": "74ca",
	"./best_on.svg": "3e3d",
	"./bg_light_orange.svg": "5a07",
	"./c_1.svg": "988b",
	"./c_2.svg": "ea72",
	"./c_3.svg": "30e5",
	"./cad_login.svg": "bd17",
	"./calender_empty.svg": "e3ec",
	"./calender_off.svg": "9346",
	"./calender_on.svg": "5fd8",
	"./chat.svg": "8255",
	"./circle.svg": "73e7",
	"./commission.svg": "6975",
	"./crm_bg.svg": "be37",
	"./download_white.svg": "88e3",
	"./email_white.svg": "0c87",
	"./empty.svg": "3a1e",
	"./eta_white.svg": "1a24",
	"./f.svg": "3648",
	"./faq.svg": "7ad3",
	"./filter.svg": "d79f",
	"./folder_empty.svg": "451c",
	"./group.svg": "1d15",
	"./hourglass.svg": "42ea",
	"./i.svg": "6aba",
	"./icon.svg": "2e95",
	"./input_tick.svg": "ae51",
	"./input_x.svg": "7b28",
	"./instagram_white.svg": "1616",
	"./level_1.svg": "0819",
	"./level_2.svg": "b63a",
	"./level_3.svg": "4365",
	"./level_4.svg": "66f0",
	"./linkedin_white.svg": "0d836",
	"./location2.svg": "5f1d",
	"./logo_c.svg": "13f6",
	"./love.svg": "5b5f",
	"./mail.svg": "9180",
	"./ost_login.svg": "c36e",
	"./our_values_lg.svg": "1151",
	"./our_values_sm.svg": "ab33",
	"./phone-call.svg": "c119",
	"./price_class.svg": "abe5",
	"./question.svg": "aefe",
	"./selected.svg": "b846",
	"./social_network/Armenia.svg": "6e05",
	"./social_network/Line.svg": "b7d6",
	"./social_network/Math.svg": "fdc9",
	"./social_network/Music.svg": "afc0",
	"./social_network/Türkiye.svg": "b05a",
	"./social_network/german.svg": "215e",
	"./social_network/iels.svg": "d5e1",
	"./social_network/other.svg": "8b9f",
	"./social_network/paper.svg": "de76",
	"./social_network/phone.svg": "936a",
	"./social_network/sports.svg": "175d",
	"./star.svg": "cf9a",
	"./star_off.svg": "2224",
	"./star_on.svg": "46bf",
	"./t.svg": "beaa",
	"./teacher.svg": "1cd1",
	"./telegram_white.svg": "3cd5",
	"./tick_white.svg": "8f4b",
	"./time_class.svg": "2ed1",
	"./tw.svg": "ce4d",
	"./upload.svg": "6ae2",
	"./whatsapp_white.svg": "9cdf",
	"./x.svg": "a336",
	"./x_white.svg": "9982",
	"./youtube_white.svg": "cc0a",
	"./zarinpal.svg": "c2f5",
	"./zibal.svg": "3dc8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e769";